import { Component, OnInit, inject } from '@angular/core';
import { SessionStorageService }  from '../../../services/session-storage.service'

@Component({
    selector: 'app-links',
    templateUrl: './app-links.component.html',
    styleUrls: ['./app-links.component.scss'],
    standalone: false
})
export class AppLinksComponent implements OnInit {
  private ss = inject(SessionStorageService);

  rights = [];

  ngOnInit() {
    this.rights = this.ss.get('rights');
  }

}
